export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS';
export const SUCCESS_GET_NOTIFICATIONS = 'SUCCESS_GET_NOTIFICATIONS';
export const FAIL_GET_NOTIFICATIONS = 'FAIL_GET_NOTIFICATIONS';

export const HAS_NOTIFICATIONS = 'HAS_NOTIFICATIONS';
export const SUCCESS_HAS_NOTIFICATIONS = 'SUCCESS_HAS_NOTIFICATIONS';
export const FAIL_HAS_NOTIFICATIONS = 'FAIL_HAS_NOTIFICATIONS';

export const GET_RESERVATIONS = 'GET_RESERVATIONS';
export const SUCCESS_GET_RESERVATIONS = 'SUCCESS_GET_RESERVATIONS';
export const FAIL_GET_RESERVATIONS = 'FAIL_GET_RESERVATIONS';

export const GET_RESERVATION = 'GET_RESERVATION';
export const SUCCESS_GET_RESERVATION = 'SUCCESS_GET_RESERVATION';
export const FAIL_GET_RESERVATION = 'FAIL_GET_RESERVATION';

export const GET_DAY_RESERVATION = 'GET_DAY_RESERVATION';
export const SUCCESS_GET_DAY_RESERVATION = 'SUCCESS_GET_DAY_RESERVATION';
export const FAIL_GET_DAY_RESERVATION = 'FAIL_GET_DAY_RESERVATION';

export const GET_DAY_NOTIFICATIONS = 'GET_DAY_NOTIFICATIONS';
export const SUCCESS_GET_DAY_NOTIFICATIONS = 'SUCCESS_GET_DAY_NOTIFICATIONS';
export const FAIL_GET_DAY_NOTIFICATIONS = 'FAIL_GET_DAY_NOTIFICATIONS';

export const GET_TEMPLATES_NOTIFICATIONS = 'GET_TEMPLATES_NOTIFICATIONS';
export const SUCCESS_GET_TEMPLATES_NOTIFICATIONS = 'SUCCESS_GET_TEMPLATES_NOTIFICATIONS';
export const FAIL_GET_TEMPLATES_NOTIFICATIONS = 'FAIL_GET_TEMPLATES_NOTIFICATIONS';

export const INIT_NOTIFICATION = 'INIT_NOTIFICATION';
export const EDIT_NOTIFICATION = 'EDIT_NOTIFICATION';

export const INIT_RESERVATION = 'INIT_RESERVATION';
export const EDIT_RESERVATION = 'EDIT_RESERVATION';

export const CANCEL_RESERVATION = 'CANCEL_RESERVATION';
export const SUCCESS_CANCEL_RESERVATION = 'SUCCESS_CANCEL_RESERVATION';
export const FAIL_CANCEL_RESERVATION = 'FAIL_CANCEL_RESERVATION';

export const VALIDATE_NOTIFICATION = 'VALIDATE_NOTIFICATION';
export const SUCCESS_VALIDATE_NOTIFICATION = 'SUCCESS_VALIDATE_NOTIFICATION';
export const FAIL_VALIDATE_NOTIFICATION = 'FAIL_VALIDATE_NOTIFICATION';

export const CREATE_NOTIFICATION = 'CREATE_NOTIFICATION';
export const SUCCESS_CREATE_NOTIFICATION = 'SUCCESS_CREATE_NOTIFICATION';
export const FAIL_CREATE_NOTIFICATION = 'FAIL_CREATE_NOTIFICATION';

export const CREATE_NOTIFICATIONS = 'CREATE_NOTIFICATIONS';
export const SUCCESS_CREATE_NOTIFICATIONS = 'SUCCESS_CREATE_NOTIFICATIONS';
export const FAIL_CREATE_NOTIFICATIONS = 'FAIL_CREATE_NOTIFICATIONS';

export const CREATE_RESERVATION = 'CREATE_RESERVATION';
export const SUCCESS_CREATE_RESERVATION = 'SUCCESS_CREATE_RESERVATION';
export const FAIL_CREATE_RESERVATION = 'FAIL_CREATE_RESERVATION';

export const UPDATE_RESERVATION = 'UPDATE_RESERVATION';
export const SUCCESS_UPDATE_RESERVATION = 'SUCCESS_UPDATE_RESERVATION';
export const FAIL_UPDATE_RESERVATION = 'FAIL_UPDATE_RESERVATION';

export const DELETE_RESERVATION = 'DELETE_RESERVATION';
export const SUCCESS_DELETE_RESERVATION = 'SUCCESS_DELETE_RESERVATION';
export const FAIL_DELETE_RESERVATION = 'FAIL_DELETE_RESERVATION';

export const DUPLICATE_RESERVATIONS = 'DUPLICATE_RESERVATIONS';
export const SUCCESS_DUPLICATE_RESERVATIONS = 'SUCCESS_DUPLICATE_RESERVATIONS';
export const FAIL_DUPLICATE_RESERVATIONS = 'FAIL_DUPLICATE_RESERVATIONS';

export const VALIDATE_RESERVATION = 'VALIDATE_RESERVATION';
export const SUCCESS_VALIDATE_RESERVATION = 'SUCCESS_VALIDATE_RESERVATION';
export const FAIL_VALIDATE_RESERVATION = 'FAIL_VALIDATE_RESERVATION';

export const REMOVE_ORDER_BREAD_FROM_NOTIFICATION = 'REMOVE_ORDER_BREAD_FROM_NOTIFICATION';
export const SUCCESS_REMOVE_ORDER_BREAD_FROM_NOTIFICATION =
  'SUCCESS_REMOVE_ORDER_BREAD_FROM_NOTIFICATION';
export const FAIL_REMOVE_ORDER_BREAD_FROM_NOTIFICATION =
  'FAIL_REMOVE_ORDER_BREAD_FROM_NOTIFICATION';
export const COMPLETE_REMOVE_ORDER_BREAD_FROM_NOTIFICATION =
  'COMPLETE_REMOVE_ORDER_BREAD_FROM_NOTIFICATION';
